import { render, staticRenderFns } from "./TestCasesTable.vue?vue&type=template&id=55230b08&scoped=true"
import script from "./TestCasesTable.vue?vue&type=script&lang=js"
export * from "./TestCasesTable.vue?vue&type=script&lang=js"
import style0 from "./TestCasesTable.vue?vue&type=style&index=0&id=55230b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55230b08",
  null
  
)

export default component.exports